module.exports = __webpack_public_path__ + "img/cheque.57917dde.svg";